import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { Content, Events, IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import moment, { now } from 'moment';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { of } from 'rxjs/observable/of';
import { concatMap, switchMap } from 'rxjs/operators';
import { ApiErrorHandlerProvider } from '../../providers/api-error-handler/api-error-handler';
import { CoffeShopService } from '../../providers/coffe-shop/coffe-shop.service';
import { ServiceSummaryPage } from '../service-summary/service-summary';
import { StaffServiceProvider } from '../../providers/staff-service/staff-service';
import { TeamServiceProvider } from '../../providers/team-service/team-service';

@IonicPage()
@Component({
    selector: 'page-reschedule',
    templateUrl: 'reschedule.html',
})
export class ReschedulePage {
    booking: any;
    loading: boolean = true;
    errors: {};
    selectedBarber: any;
    public timeLoading: boolean = false;
    public errorMessage: string = '';
    public disableContinueButton: boolean = false;
    isFromQueue: boolean = false;

    selectedIndex: any = 0;
    AllBarbers: any[] = [];
    dateTimeLoading: boolean = false;

    todayCancelledBooking: any[] = [];
    todayBooking: any[] = [];
    selectedServicesDuration: any = 0;
    loading1: boolean = false;
    currentTimeZone: any;
    advanceBookings: any[] = [];
    @ViewChild(Content) content: Content;
    constructor(public viewCtrl: ViewController,
        public navParams: NavParams,
        public events: Events,
        private http: HttpClient,
        private apiErrorHandler: ApiErrorHandlerProvider,
        public coffeShopService: CoffeShopService,
        public staffService: StaffServiceProvider,
        public navCtrl: NavController,
        private teamService: TeamServiceProvider
    ) {
        this.booking = navParams.get('booking');
        this.isFromQueue = navParams.get('isFromQueue') || false;
        if (typeof (this.booking) != "undefined" && this.booking != null && this.booking.services.length > 0 && !this.isFromQueue) {
            this.selectedServicesDuration = this.booking.services.reduce((acc, item) => acc + Number((item.duration * item.quantity)), 0);
            this.booking.services.forEach(element => {
                if (element.name.split('x')[1]) {
                    element.name = element.name.split('x')[1].trim();
                }
            });
        } else {
            if ((typeof (this.booking) != "undefined" && this.booking != null && this.booking.booking && this.booking.booking.services.length > 0)) {
                this.selectedServicesDuration = this.booking.booking.services.reduce((acc, item) => acc + Number((item.service.service.duration * item.quantity)), 0);
                this.booking.booking.services.forEach(element => {
                    if (element.name.split('x')[1]) {
                        element.name = element.name.split('x')[1].trim();
                    }
                });
            }
        }

        let team_id = this.isFromQueue ? this.booking.team_id : this.booking.team.id;
        this.coffeShopService.getCoffeShop(team_id).subscribe(
            res => {
                this.coffeShopService.bookingDates = [];
                this.coffeShopService.bookingTimes = [];
                this.coffeShopService.coffeShop = res;
                this.chooseDateAndTime();
            });
    }

    ionViewDidLoad() {
    }

    public async chooseDateAndTime(): Promise<void> {
        this.coffeShopService.showChooseDate = true;
        this.timeLoading = true;
        const now = new Date(new Date(new Date(new Date(new Date(new Date(new Date().toLocaleString("en-US", { timeZone: this.coffeShopService.coffeShop.timezone.timezone })).setHours(0)).setMinutes(0)).setSeconds(0))).setMilliseconds(0));
        // setTimeout(() => this.content.scrollToBottom(), 0);
        this.coffeShopService.getCoffeShop(this.coffeShopService.coffeShop.id)
            .pipe(switchMap((shop: any) => {
                this.proccessShop(shop);
                if ((this.coffeShopService.user.advanced_booking_hours || this.coffeShopService.user.is_available) || this.isFromQueue) {
                    return this.coffeShopService.advancedBookingRequest({ date: '', available: true }, true)
                        .pipe(switchMap((barbers) => {
                            let selectedBarberIndex = barbers.findIndex(i => i.id == this.selectedBarber.id);

                            this.AllBarbers = this.AllBarbers ? this.AllBarbers : barbers;
                            this.selectedBarber = this.selectedBarber ? this.selectedBarber : barbers[0];
                            if (selectedBarberIndex != -1) {
                                this.selectedBarber.holiday = barbers[selectedBarberIndex] && barbers[selectedBarberIndex].holiday ? barbers[selectedBarberIndex].holiday : [];
                            } else {
                                selectedBarberIndex = this.AllBarbers.findIndex(i => i.id == this.selectedBarber.id);
                                if (selectedBarberIndex !== -1) {
                                    this.selectedBarber.holiday = this.AllBarbers[selectedBarberIndex] && this.AllBarbers[selectedBarberIndex].holiday ? this.AllBarbers[selectedBarberIndex].holiday : [];
                                } else {
                                    this.selectedBarber.holiday = [];
                                }
                            }
                            this.proccessAdanceBookingRequest({ date: '', available: true }, barbers, null);
                            this.openCalendar();
                            if (this.coffeShopService.bookingDates.length) {
                                this.coffeShopService.selectedDate = this.coffeShopService.bookingDates.find((date) => date.available).date as any;
                                const formattedDate = this.coffeShopService.requestDateFormatter(this.coffeShopService.selectedDate);
                                return forkJoin([of(barbers), this.coffeShopService.getAvailableBookingTimes(formattedDate, this.selectedBarber)])
                            } else {
                                return forkJoin([of(barbers), of(null)])
                            }
                        }))
                } else {
                    return of(shop);
                }
            })).subscribe(async ([barbers, times]: any) => {
                const timezoen = new Date(new Date().toLocaleString("en-US", { timeZone: this.coffeShopService.coffeShop.timezone.timezone }));

                if (times == null) {
                    times = [];
                }

                if (times && times.length > 0) {
                    for (let Tindex = 0; Tindex < times.length; Tindex++) {
                        const element = times[Tindex];

                        if (element.available && times[times.length - 1] !== element) {
                            let duration = element.time_difference_in_minutes;

                            for (let index = Tindex + 1; index < times.length; index++) {
                                if (times[index].available) {
                                    duration += times[index].time_difference_in_minutes;
                                } else {
                                    break;
                                }
                            }

                            element.available = duration >= this.selectedServicesDuration;
                        } else if (times[times.length - 1] === element && element.available == true) {
                            element.available = element.time_difference_in_minutes >= this.selectedServicesDuration;
                        }
                    }
                }
                // try {
                //     await this.getBarberWithBookings().then(
                //         (res: any) => {
                //             this.advanceBookings = res;
                //             if (this.advanceBookings && this.advanceBookings.length > 0) {
                //                 this.advanceBookings = this.advanceBookings.sort((a: any, b: any) => {
                //                     return new Date(a.booking.requested_booking_time).getTime() - new Date(b.booking.requested_booking_time).getTime();
                //                 });

                //                 for (let index = 0; index < this.advanceBookings.length; index++) {
                //                     if (index != (this.advanceBookings.length - 1)) {
                //                         let upcomingadv = this.advanceBookings[index + 1].booking.estimated_booking_time ? new Date(this.advanceBookings[index + 1].booking.estimated_booking_time) : new Date(this.advanceBookings[index + 1].booking.requested_booking_time);

                //                         let currentAdVTime = this.advanceBookings[index].booking.estimated_booking_time ? this.advanceBookings[index].booking.estimated_booking_time : this.advanceBookings[index].booking.requested_booking_time;
                //                         let newdateAdvc = new Date(new Date(new Date(currentAdVTime)).getTime() + this.advanceBookings[index].booking.getDuration * 60000);
                //                         let differenceAdv = new Date(upcomingadv).getTime() - new Date(newdateAdvc).getTime();
                //                         differenceAdv = differenceAdv / 60000;
                //                         if (this.selectedServicesDuration <= Math.ceil(differenceAdv)  && new Date(newdateAdvc).getTime() > new Date(timezoen).getTime()) {
                //                             times.push({ date: moment(newdateAdvc).format('YYYY-MM-DD HH:mm:ss'), available: true });
                //                         }
                //                     }
                //                 }
                //             }
                //         });
                // } catch (error) {

                // }

                if (this.coffeShopService.coffeShop) {
                    this.teamService.filterAvailableUsers(this.coffeShopService.coffeShop).then((filteredShopAvailableUsers: any) => {
                        if (filteredShopAvailableUsers.users.length > 0 && this.AllBarbers.length > 0) {
                            filteredShopAvailableUsers.users.forEach(element => {
                                if (this.AllBarbers.findIndex(item => item.id == element.id) !== 0) {
                                    this.AllBarbers.push(element);
                                }
                            });
                        }
                    });
                }

                if (barbers) {
                    let selectedBarber = barbers.findIndex(i => i.id == this.selectedBarber.id);
                    if (selectedBarber !== -1) {
                        let holidays = this.coffeShopService.daysConfig(barbers[selectedBarber]);
                        // this.selectedBarber.holiday = barbers[selectedBarber].holiday
                        let index = holidays.findIndex(item => moment(item.date).format('DD/MM/YYYY') == moment().format('DD/MM/YYYY'));
                        if (index !== -1) {
                            this.selectedBarber.isHolidayToday = true;
                        } else {
                            this.selectedBarber.isHolidayToday = false;
                        }
                    }
                }

                // if ((times && times.length > 0) && this.selectedServicesDuration > this.coffeShopService.coffeShop.settings.advanced_bookings_time_interval) {
                //     let nextSlots = this.selectedServicesDuration / this.coffeShopService.coffeShop.settings.advanced_bookings_time_interval;
                //     let nextSlotsArray = nextSlots.toString().split(".");
                //     let noofSlots: number = 1;
                //     if (nextSlotsArray[1]) {
                //         noofSlots = (Number(nextSlotsArray[0]) + 1);
                //     } else {
                //         noofSlots = Number(nextSlotsArray[0]);
                //     }

                //     times.forEach((element, index) => {
                //         if (element.available && times[times.length -1] !== element ) {
                //             let nextElements = [];
                //             for (let t = 1; t < noofSlots; t++) {
                //                 if (times[(index + t)]) {
                //                     nextElements.push(times[(index + t)].available);
                //                 } else {
                //                     nextElements.push(false);
                //                 }
                //             }
                //             element.available = nextElements.some(res => res == false) ? false : true;
                //         }
                //     });
                // }
                // if ((times && times.length > 0) && this.todayBooking.length > 0) {
                //     times.forEach((element, index) => {
                //         this.todayBooking.forEach(todayBookings => {
                //             if (times[index + 1] && new Date(element.date) <= new Date(todayBookings.estimated_booking_time) && new Date(times[index + 1].date) >= new Date(todayBookings.estimated_booking_time)) {
                //                 element.available = false;
                //             }

                //             let newdate = new Date(new Date(new Date(todayBookings.estimated_booking_time)).getTime() + todayBookings.available_duration * 60000);
                //             if (times[index + 1] && new Date(element.date) <= (new Date(newdate)) && new Date(times[index + 1].date) >= new Date(newdate)) {
                //                 element.available = false;
                //             }
                //         });
                //     });
                // }

                if (times && times.length > 0) {
                    // times = this.CheckLastSlots(times);
                    // if(now === new Date(this.coffeShopService.selectedDate)){
                    //     times = this.CheckLastSlots(times);
                    // }
                    times = times.sort((a, b) => a.date.localeCompare(b.date));
                    times = this.removeDuplicates(times);
                }
                if (this.coffeShopService.bookingDates.length && barbers && times) {
                    this.proccessAdanceBookingRequest(this.coffeShopService.bookingDates[0], barbers, times);
                }
                // if (this.coffeShopService.coffeShop.has_active_barbers) {
                //     this.checkBarberIsFree();
                // }
                this.timeLoading = false;
                this.dateTimeLoading = false;
                this.loading = false;
                setTimeout(() => { if (this.content) this.content.scrollToBottom() }, 0);
            }, (error: HttpErrorResponse) => {
                this.timeLoading = false;
                this.dateTimeLoading = false;
                this.loading = false;
                setTimeout(() => { if (this.content) this.content.scrollToBottom() }, 0);
            });
    }

    getBarberWithBookings() {
        const now = new Date(new Date(new Date(new Date(new Date(new Date(new Date().toLocaleString("en-US", { timeZone: this.coffeShopService.coffeShop.timezone.timezone })).setHours(0)).setMinutes(0)).setSeconds(0))).setMilliseconds(0));
        if (this.coffeShopService.selectedDate == null || this.coffeShopService.selectedDate == "") {
            this.coffeShopService.selectedDate = now as any;
        }
        return new Promise((resolve, reject) => {
            this.http.get(`/getAdvBooking/${this.selectedBarber.id}`,
                { params: { bookingDate: moment(this.coffeShopService.selectedDate).format("DD/MM/YYYY") } }
            ).subscribe((barber: any) => {
                resolve(barber);
            }, error => {
                resolve(null);
            })
        });
    }

    public CheckLastSlots(times): any {
        let isLastSlotsBooked: boolean = false;
        const timezoen = new Date(new Date().toLocaleString("en-US", { timeZone: this.coffeShopService.coffeShop.timezone.timezone }));
        const today_day = moment(timezoen).format('dddd').toLocaleLowerCase();
        let nowMoment = this.convertTZ(new Date(), this.coffeShopService.coffeShop.timezone.timezone);

        const barmen_time_end = this.coffeShopService.user.hours[`${today_day}`] ?
            `${this.coffeShopService.user.hours[`${today_day}`].split(':')[0]}:${this.coffeShopService.user.hours[`${today_day}`].split(':')[1]}` : null;

        const barmen_adv_time_end = this.coffeShopService.user.advanced_booking_hours && this.coffeShopService.user.advanced_booking_hours[`${today_day}`] ?
            `${this.coffeShopService.user.advanced_booking_hours[`${today_day}` + '_end'].split(':')[0]}:${this.coffeShopService.user.advanced_booking_hours[`${today_day}` + '_end'].split(':')[1]}` : null;

        if ((barmen_time_end || barmen_adv_time_end) && times.length > 0) {
            if (!times[times.length - 1].available) {

                if (this.selectedBarber.today_advanced_bookings.length > 0) {
                    let lastElement = this.selectedBarber.today_advanced_bookings[this.selectedBarber.today_advanced_bookings.length - 1];
                    let currentAdVTime = lastElement.estimated_booking_time ? lastElement.estimated_booking_time : lastElement.requested_booking_time;
                    let newdate = new Date(new Date(new Date(currentAdVTime).setSeconds(0)).getTime() + lastElement.getDuration * 60000);
                    let end = barmen_time_end.split(":");
                    const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));

                    let differenceAdv = new Date(endTime).getTime() - new Date(newdate).getTime();
                    differenceAdv = differenceAdv / 60000;
                    if (this.selectedServicesDuration <= Math.ceil(differenceAdv)) {
                        times.push({ date: moment(newdate).format('YYYY-MM-DD HH:mm:ss'), available: true });
                        // times.push({ date: new Date(newdate), available: true });
                        // return times;
                    }

                    let isExistLastSlotBooking = this.selectedBarber.today_advanced_bookings.findIndex(item => new Date(item.requested_booking_time).getTime() == new Date(times[times.length - 1].date).getTime());
                    if (isExistLastSlotBooking !== -1) {
                        isLastSlotsBooked = true;
                    }
                }

                if (barmen_adv_time_end && barmen_time_end) {
                    let advEnd = barmen_adv_time_end.split(":");
                    const BarberAdvEndTime = new Date(nowMoment).setHours(Number(advEnd[0]), Number(advEnd[1]));

                    let end = barmen_time_end.split(":");
                    const BarberEndTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));

                    // Check advance hours less then barber reaular hours 
                    if (new Date(BarberAdvEndTime).getTime() > new Date(BarberEndTime).getTime()) {
                        const endTime = new Date(nowMoment).setHours(Number(advEnd[0]), Number(advEnd[1]));
                        const lastSlot = new Date(times[times.length - 1].date);

                        let differenceAdv = new Date(endTime).getTime() - new Date(lastSlot).getTime();
                        differenceAdv = differenceAdv / 60000;
                        if (this.selectedServicesDuration <= Math.ceil(differenceAdv) && !isLastSlotsBooked) {
                            times[times.length - 1].available = true;
                            return times;
                        }
                        return times;
                    }
                    // return times;
                }

                if (barmen_time_end) {
                    let end = barmen_time_end.split(":");
                    const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                    const lastSlot = new Date(times[times.length - 1].date);
                    if (new Date(lastSlot).getTime() > new Date(nowMoment).getTime()) {
                        let differenceAdv = new Date(endTime).getTime() - new Date(lastSlot).getTime();
                        differenceAdv = differenceAdv / 60000;
                        if (this.selectedServicesDuration <= Math.ceil(differenceAdv) && !isLastSlotsBooked) {
                            times[times.length - 1].available = true;
                            return times;
                        }
                    }
                }
            }

        }

        return times;
    }

    private async proccessShop(shop): Promise<void> {
        this.currentTimeZone = new Date(new Date().toLocaleString("en-US", { timeZone: shop.timezone.timezone }));
        if (shop.users) {
            let filteredUsers = [];
            for (var i = 0; i < shop.users.length; i++) {
                let user = shop.users[i];
                if (user.today_advanced_bookings && user.today_advanced_bookings.length > 0) {
                    user.today_advanced_bookings = user.today_advanced_bookings.filter(res => res.requested_booking_time && res.estimated_booking_time == null);
                }
                filteredUsers.push(user);
            }
            shop.users = filteredUsers;
        }
        if (shop.users) {
            this.AllBarbers = shop.users.filter(res => res.hours != null || res.advanced_booking_hours != null);
        }

        if (this.isFromQueue) {
            // this.selectedBarber = this.selectedBarber ? this.selectedBarber : this.AllBarbers[0];
            this.selectedBarber = shop.users.filter((barber) => barber.id == (this.selectedBarber ? this.selectedBarber.id : this.booking.booking.staff_member.user_id))[0];
        } else {
            this.selectedBarber = shop.users.filter((barber) => barber.id == this.booking.staff_member.user.id)[0];
        }
        this.coffeShopService.shop = shop;
        this.coffeShopService.user = this.selectedBarber;
        this.coffeShopService.bookingTimes = [];
        this.coffeShopService.bookingDates = [];
        this.getFirstBookingDate();
        this.getLastBookingDate();
        this.todayCancelledBooking = [];
        this.todayBooking = [];
        await this.getavailableDuration();
        await this.getAdvAvailableDuration();
        if (this.todayBooking.length > 0) {
            this.todayBooking = this.todayBooking.sort((a, b) => parseFloat(b.id) - parseFloat(a.id));
        }
    }



    getLastBookingDate() {
        let daysBookingCanBeMadeInAdvance = this.coffeShopService.shop.settings ? this.coffeShopService.shop.settings.num_days_bookings_can_be_made_in_advance : 7;
        this.coffeShopService.lastBookingDate = moment().add(daysBookingCanBeMadeInAdvance, 'days');
        this.coffeShopService.lastBookingDate = new Date(this.coffeShopService.lastBookingDate.get('year'), this.coffeShopService.lastBookingDate.get('month'), this.coffeShopService.lastBookingDate.get('date'));
    }
    getFirstBookingDate() {
        let date = moment(this.coffeShopService.shop.first_advanced_booking_date, 'YYYY-MM-DD');
        this.coffeShopService.firstBookingDate = new Date(date.get('year'), date.get('month'), date.get('date'));
    }

    private proccessAdanceBookingRequest(booking, barbers, times) {

        if (times && times.length) {
            times = times.filter((timeObj) => timeObj.available).map(timeObj => {
                timeObj.date = moment(timeObj.date).format('HH:mm');
                return timeObj;
            })
            this.coffeShopService.bookingTimes = times;
            this.coffeShopService.selectedTime = this.coffeShopService.bookingTimes.some((time) => time.available) ? this.coffeShopService.bookingTimes.find((timeObject) => timeObject.available === true).date : '';
        }
        if (barbers) {
            this.coffeShopService.barbers = barbers;
        }
        if (!this.coffeShopService.allBarbers || !booking.date) {
            this.coffeShopService.allBarbers = barbers;
        }
    }


    public checkBarberIsFree(): void {

        const now = new Date(new Date(new Date(new Date(new Date(new Date(new Date().toLocaleString("en-US", { timeZone: this.coffeShopService.coffeShop.timezone.timezone })).setHours(0)).setMinutes(0)).setSeconds(0))).setMilliseconds(0));
        const timezoen = new Date(new Date().toLocaleString("en-US", { timeZone: this.coffeShopService.coffeShop.timezone.timezone }));
        const today_time = `${timezoen.getHours() >= 10 ? timezoen.getHours() : `0` + timezoen.getHours()}:${timezoen.getMinutes() >= 10 ? timezoen.getMinutes() : `0` + timezoen.getMinutes()}`
        const today_day = moment(timezoen).format('dddd').toLocaleLowerCase();
        let nowMoment = this.convertTZ(new Date(), this.coffeShopService.coffeShop.timezone.timezone);

        const barmen_time_end = this.coffeShopService.user.hours[`${today_day}`] ?
            `${this.coffeShopService.user.hours[`${today_day}`].split(':')[0]}:${this.coffeShopService.user.hours[`${today_day}`].split(':')[1]}` : null;

        const barmen_adv_time_end = this.coffeShopService.user.advanced_booking_hours && this.coffeShopService.user.advanced_booking_hours[`${today_day}`] ?
            `${this.coffeShopService.user.advanced_booking_hours[`${today_day}` + '_end'].split(':')[0]}:${this.coffeShopService.user.advanced_booking_hours[`${today_day}` + '_end'].split(':')[1]}` : null;

        const barmen_has_andvanced_booking = !!this.coffeShopService.user.advanced_booking_hours;
        if (!barmen_has_andvanced_booking && !barmen_time_end && !this.coffeShopService.coffeShop.hours[`${today_day}`]) {
            //   this.disableContinueButton = true;
            this.errorMessage = 'Queue is full';
            return;
        }
        let time = null;
        let availableSlots = [];

        if (this.coffeShopService.user && (this.coffeShopService.user.current_queue_length > 0 || this.selectedBarber.today_advanced_bookings.length > 0)) {

            // if (this.selectedBarber.todays_cancelled_bookings.length == 0 && this.selectedBarber.today_advanced_bookings.length == 0) {
            //     this.coffeShopService.user.current_chair_time_with_cancelled = this.coffeShopService.user.current_chair_time_with_cancelled.toUpperCase();
            //     time = this.coffeShopService.user.current_chair_time_with_cancelled.includes('AM') ?
            //         this.coffeShopService.convert12to24(this.coffeShopService.user.current_chair_time_with_cancelled.split('AM').join(' AM')) :
            //         this.coffeShopService.convert12to24(this.coffeShopService.user.current_chair_time_with_cancelled.split('PM').join(' PM'));
            //     availableSlots.push({ date: time, available: true, booking_type: 1 });
            // } else  if (this.todayBooking.length > 0 && this.selectedBarber.today_advanced_bookings.length == 0) {
            //     let durationElement: any = this.todayBooking.filter(res => res.id == this.selectedBarber.todays_booking[this.selectedBarber.todays_booking.length - 1].id)[0];
            //     if(durationElement){
            //         // let nowMoment = this.convertTZ(new Date(), this.coffeShopService.coffeShop.timezone.timezone);
            //         let newdate = new Date(new Date(new Date(durationElement.estimated_booking_time).setSeconds(0)).getTime() + durationElement.available_duration * 60000);
            //         if(moment(newdate).format('DD/MM/YYYY') == moment(nowMoment).format('DD/MM/YYYY') && (moment(newdate).format('HH:mm') < barmen_time_end)){
            //           if (time == null)
            //               time = moment(newdate).format('HH:mm');
            //           availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
            //       }
            //     }
            // }

            if (this.selectedBarber.todays_cancelled_bookings.length == 0 && this.selectedBarber.today_advanced_bookings.length == 0) {
                let todayEndTime = this.coffeShopService.user.hours && this.coffeShopService.user.hours[`${today_day}`] != null ? this.coffeShopService.user.hours[`${today_day}`] : null;
                if (todayEndTime) {
                    let end = todayEndTime.split(":");
                    this.coffeShopService.user.current_chair_time_with_cancelled = this.coffeShopService.user.current_chair_time_with_cancelled.toUpperCase();
                    let current_chair_time_with_cancelled = this.coffeShopService.user.current_chair_time_with_cancelled.includes('AM') ?
                        this.coffeShopService.convert12to24(this.coffeShopService.user.current_chair_time_with_cancelled.split('AM').join(' AM')) :
                        this.coffeShopService.convert12to24(this.coffeShopService.user.current_chair_time_with_cancelled.split('PM').join(' PM'));

                    const lastQueue = new Date(nowMoment).setHours(Number(current_chair_time_with_cancelled.split(":")[0]), Number(current_chair_time_with_cancelled.split(":")[1]));
                    const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                    let differenceAdv = new Date(endTime).getTime() - new Date(lastQueue).getTime();
                    differenceAdv = Math.ceil(differenceAdv / 60000);
                    if (this.selectedServicesDuration <= Math.ceil(differenceAdv)) {
                        if (time == null)
                            time = current_chair_time_with_cancelled;
                        availableSlots.push({ date: current_chair_time_with_cancelled, available: true, booking_type: 1 });
                    }
                    // else {
                    //     this.errorMessage = 'Queue is full';
                    //     return;
                    // }

                } else {

                    this.coffeShopService.user.current_chair_time_with_cancelled = this.coffeShopService.user.current_chair_time_with_cancelled.toUpperCase();
                    time = this.coffeShopService.user.current_chair_time_with_cancelled.includes('AM') ?
                        this.coffeShopService.convert12to24(this.coffeShopService.user.current_chair_time_with_cancelled.split('AM').join(' AM')) :
                        this.coffeShopService.convert12to24(this.coffeShopService.user.current_chair_time_with_cancelled.split('PM').join(' PM'));
                    availableSlots.push({ date: time, available: true, booking_type: 1 });
                }
            } else if (this.todayBooking.length > 0 && this.selectedBarber.today_advanced_bookings.length == 0) {
                let durationElement: any = this.todayBooking.filter(res => res.id == this.selectedBarber.todays_booking[this.selectedBarber.todays_booking.length - 1].id)[0];
                if (durationElement) {
                    let newdate = new Date(new Date(new Date(durationElement.estimated_booking_time).setSeconds(0)).getTime() + durationElement.available_duration * 60000);

                    let todayEndTime = this.coffeShopService.user.hours && this.coffeShopService.user.hours[`${today_day}`] != null ? this.coffeShopService.user.hours[`${today_day}`] : null;
                    if (todayEndTime) {
                        let end = todayEndTime.split(":");
                        const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                        let differenceAdv = new Date(endTime).getTime() - new Date(newdate).getTime();
                        differenceAdv = Math.ceil(differenceAdv / 60000);
                        if (this.selectedServicesDuration <= Math.ceil(differenceAdv)) {
                            if (time == null)
                                time = moment(newdate).format('HH:mm');
                            availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                        }
                        //  else {
                        //     this.errorMessage = 'Queue is full';
                        //     return;
                        // }
                    } else {
                        if (moment(newdate).format('DD/MM/YYYY') == moment(nowMoment).format('DD/MM/YYYY') && (moment(newdate).format('HH:mm') < barmen_time_end)) {
                            if (time == null)
                                time = moment(newdate).format('HH:mm');
                            availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                        }
                    }
                }
            }

            if (this.todayCancelledBooking.length > 0) {
                for (var element of this.todayCancelledBooking) {
                    let differenceAdv = new Date(this.currentTimeZone).getTime() - new Date(element.estimated_booking_time).getTime();
                    differenceAdv = Math.ceil(differenceAdv / 60000);
                    differenceAdv = element.available_duration - differenceAdv;
                    if (this.selectedServicesDuration <= element.available_duration && (new Date(timezoen).getTime() <= new Date(element.estimated_booking_time).getTime())) {
                        // if (this.selectedServicesDuration <= element.available_duration) {
                        let availableTime = element.estimated_chair_time_string.toString().toUpperCase().includes('AM') ?
                            this.coffeShopService.convert12to24(element.estimated_chair_time_string.toString().toUpperCase().split('AM').join(' AM')) :
                            this.coffeShopService.convert12to24(element.estimated_chair_time_string.toString().toUpperCase().split('PM').join(' PM'));
                        if (time == null) {
                            time = availableTime;
                        }
                        availableSlots.push({ date: availableTime, available: true, booking_type: 1 });
                    }
                    else if (this.selectedServicesDuration <= differenceAdv && new Date(timezoen).getTime() >= new Date(element.estimated_booking_time).getTime()) {
                        if (time == null) {
                            time = today_time;
                        }
                        availableSlots.push({ date: today_time, available: true, booking_type: 1 });
                    }
                }
            }

            // if (this.todayBooking.length > 0 && this.selectedBarber.today_advanced_bookings.length == 0) {
            //     let durationElement: any = this.todayBooking.filter(res => res.id == this.selectedBarber.todays_booking[this.selectedBarber.todays_booking.length - 1].id)[0];
            //     console.log(durationElement);
            //     if(durationElement){
            //         let newdate = new Date(new Date(new Date(durationElement.estimated_booking_time)).getTime() + durationElement.available_duration * 60000);
            //         if (time == null)
            //         time = moment(newdate).format('HH:mm');
            //         availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
            //     }
            // }

            if (this.todayBooking[this.todayBooking.length - 1] && this.selectedBarber.today_advanced_bookings[0]) {
                let todayAdvanceBookings = this.selectedBarber.today_advanced_bookings.filter(res => res.requested_booking_time && res.estimated_booking_time == null);
                let estimated_booking_time = this.selectedBarber.todays_booking[this.selectedBarber.todays_booking.length - 1].estimated_booking_time;
                let requested_booking_time = todayAdvanceBookings[0].requested_booking_time;
                let durationElement: any = this.todayBooking.filter(res => res.id == this.selectedBarber.todays_booking[this.selectedBarber.todays_booking.length - 1].id)[0];
                let newdate = new Date(new Date(new Date(estimated_booking_time)).getTime() + durationElement.available_duration * 60000);

                let difference = new Date(requested_booking_time).getTime() - new Date(newdate).getTime();
                difference = difference / 60000;
                if (this.selectedServicesDuration <= Math.ceil(difference)) {
                    if (time == null)
                        time = moment(newdate).format('HH:mm');
                    availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                }

                for (let index = 0; index < this.selectedBarber.today_advanced_bookings.length; index++) {
                    if (index != (this.selectedBarber.today_advanced_bookings.length - 1)) {
                        let upcomingadv = this.selectedBarber.today_advanced_bookings[index + 1].estimated_booking_time ? new Date(this.selectedBarber.today_advanced_bookings[index + 1].estimated_booking_time) : new Date(this.selectedBarber.today_advanced_bookings[index + 1].requested_booking_time);
                        let currentAdVTime = this.selectedBarber.today_advanced_bookings[index].estimated_booking_time ? this.selectedBarber.today_advanced_bookings[index].estimated_booking_time : this.selectedBarber.today_advanced_bookings[index].requested_booking_time;
                        let newdateAdvc = new Date(new Date(new Date(currentAdVTime)).getTime() + this.selectedBarber.today_advanced_bookings[index].getDuration * 60000);
                        let differenceAdv = new Date(upcomingadv).getTime() - new Date(newdateAdvc).getTime();
                        differenceAdv = differenceAdv / 60000;
                        if (this.selectedServicesDuration <= Math.ceil(differenceAdv)) {
                            if (time == null)
                                time = moment(newdateAdvc).format('HH:mm');

                            availableSlots.push({ date: moment(newdateAdvc).format('HH:mm'), available: true, booking_type: 1 });
                        }
                    }
                }

                if (this.selectedBarber && this.selectedBarber.today_advanced_bookings && this.selectedBarber.today_advanced_bookings.length == 1) {
                    let durationElement: any = this.selectedBarber.today_advanced_bookings[0];
                    if (durationElement) {
                        if (barmen_adv_time_end) {
                            let end = barmen_adv_time_end.split(":");
                            const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                            let newdate = new Date(new Date(new Date(durationElement.requested_booking_time).setSeconds(0)).getTime() + durationElement.getDuration * 60000);
                            let differenceAdv = new Date(endTime).getTime() - new Date(newdate).getTime();
                            differenceAdv = differenceAdv / 60000;
                            if (this.selectedServicesDuration <= Math.ceil(differenceAdv)) {
                                if (time == null)
                                    time = moment(newdate).format('HH:mm');
                                availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                            }
                        } else {
                            let newdate = new Date(new Date(new Date(durationElement.requested_booking_time).setSeconds(0)).getTime() + durationElement.getDuration * 60000);
                            if (moment(newdate).format('DD/MM/YYYY') == moment(nowMoment).format('DD/MM/YYYY') && (moment(newdate).format('HH:mm') < barmen_adv_time_end)) {
                                if (time == null)
                                    time = moment(newdate).format('HH:mm');
                                availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                            }
                        }
                    }

                    if (barmen_time_end) {
                        let durationElement: any = this.selectedBarber.today_advanced_bookings[this.selectedBarber.today_advanced_bookings.length - 1];
                        if (durationElement) {
                            let end = barmen_time_end.split(":");
                            const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                            let newdate = new Date(new Date(new Date(durationElement.requested_booking_time).setSeconds(0)).getTime() + durationElement.getDuration * 60000);
                            let differenceAdv = new Date(endTime).getTime() - new Date(newdate).getTime();
                            differenceAdv = differenceAdv / 60000;
                            if (this.selectedServicesDuration <= Math.ceil(differenceAdv) && moment(newdate).format('DD/MM/YYYY') == moment(nowMoment).format('DD/MM/YYYY') && (moment(newdate).format('HH:mm') < barmen_time_end)) {
                                if (time == null)
                                    time = moment(newdate).format('HH:mm');

                                availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                            }
                        }
                    }
                }

                if (this.isBarberQueueFull(this.selectedBarber)) {
                    time = null;
                    availableSlots = [];
                }
            }

            // if (this.coffeShopService.user.current_queue_length <= 0 && this.selectedBarber.today_advanced_bookings.length > 0) {
            //     if (barmen_time_end) {
            //         if (today_time < barmen_time_end) {
            //           let upcomingadv = new Date(this.selectedBarber.today_advanced_bookings[0].requested_booking_time);
            //           let differenceAdv = new Date(upcomingadv).getTime() - new Date(nowMoment).getTime();
            //           differenceAdv = differenceAdv / 60000;
            //           if (this.selectedServicesDuration <= Math.ceil(differenceAdv)) {
            //             if (time == null)
            //               time = today_time;

            //             availableSlots.push({ date: today_time, available: true, booking_type: 1 });
            //           }
            //         }
            //       }

            //     if (typeof (this.selectedBarber.today_advanced_bookings) != "undefined"
            //     && this.selectedBarber.today_advanced_bookings != null
            //     && this.selectedBarber.today_advanced_bookings.length > 1) {

            //     let durationElement: any = this.selectedBarber.today_advanced_bookings[this.selectedBarber.today_advanced_bookings.length - 1];
            //     if (durationElement) {
            //       let newdate = new Date(new Date(new Date(durationElement.requested_booking_time).setSeconds(0)).getTime() + durationElement.getDuration * 60000);
            //       if (moment(newdate).format('DD/MM/YYYY') == moment(nowMoment).format('DD/MM/YYYY') && (moment(newdate).format('HH:mm') < barmen_adv_time_end)) {
            //         if (time == null)
            //           time = moment(newdate).format('HH:mm');
            //         availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
            //       }
            //     }

            //     for (let index = 0; index < this.selectedBarber.today_advanced_bookings.length; index++) {
            //       if (index != (this.selectedBarber.today_advanced_bookings.length - 1)) {
            //         let upcomingadv = new Date(this.selectedBarber.today_advanced_bookings[index + 1].requested_booking_time);
            //         let newdateAdvc = new Date(new Date(new Date(this.selectedBarber.today_advanced_bookings[index].requested_booking_time)).getTime() + this.selectedBarber.today_advanced_bookings[index].getDuration * 60000);
            //         let differenceAdv = new Date(upcomingadv).getTime() - new Date(newdateAdvc).getTime();
            //         differenceAdv = differenceAdv / 60000;
            //         if (this.selectedServicesDuration <= Math.ceil(differenceAdv)) {
            //           if (time == null)
            //             time = moment(newdateAdvc).format('HH:mm');

            //           availableSlots.push({ date: moment(newdateAdvc).format('HH:mm'), available: true, booking_type: 1 });
            //         }
            //       }
            //     }
            //   } else {
            //     let durationElement: any = this.selectedBarber.today_advanced_bookings[0];
            //     if (durationElement) {
            //       let newdate = new Date(new Date(new Date(durationElement.requested_booking_time).setSeconds(0)).getTime() + durationElement.getDuration * 60000);
            //       if (moment(newdate).format('DD/MM/YYYY') == moment(nowMoment).format('DD/MM/YYYY') && (moment(newdate).format('HH:mm') < barmen_adv_time_end)) {
            //         if (time == null)
            //           time = moment(newdate).format('HH:mm');
            //         availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
            //       }
            //     }
            //   }
            // }

            if (this.coffeShopService.user.current_queue_length <= 0 && this.selectedBarber.today_advanced_bookings.length > 0) {
                if (barmen_time_end) {
                    if (today_time < barmen_time_end) {
                        let upcomingadv = new Date(this.selectedBarber.today_advanced_bookings[0].requested_booking_time);
                        let differenceAdv = new Date(upcomingadv).getTime() - new Date(nowMoment).getTime();
                        differenceAdv = differenceAdv / 60000;
                        if (this.selectedServicesDuration <= Math.ceil(differenceAdv)) {
                            if (time == null)
                                time = today_time;

                            availableSlots.push({ date: today_time, available: true, booking_type: 1 });
                        }
                    }
                }

                if (typeof (this.selectedBarber.today_advanced_bookings) != "undefined"
                    && this.selectedBarber.today_advanced_bookings != null
                    && this.selectedBarber.today_advanced_bookings.length > 1) {
                    let durationElement: any = this.selectedBarber.today_advanced_bookings[this.selectedBarber.today_advanced_bookings.length - 1];
                    if (durationElement) {
                        if (barmen_adv_time_end) {
                            let end = barmen_adv_time_end.split(":");
                            const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                            let newdate = new Date(new Date(new Date(durationElement.requested_booking_time).setSeconds(0)).getTime() + durationElement.getDuration * 60000);
                            let differenceAdv = new Date(endTime).getTime() - new Date(newdate).getTime();
                            differenceAdv = differenceAdv / 60000;
                            if (this.selectedServicesDuration <= Math.ceil(differenceAdv) && moment(newdate).format('DD/MM/YYYY') == moment(nowMoment).format('DD/MM/YYYY') && (moment(newdate).format('HH:mm') < barmen_adv_time_end)) {
                                if (time == null)
                                    time = moment(newdate).format('HH:mm');

                                availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                            }
                        } else {
                            let newdate = new Date(new Date(new Date(durationElement.requested_booking_time).setSeconds(0)).getTime() + durationElement.getDuration * 60000);
                            if (moment(newdate).format('DD/MM/YYYY') == moment(nowMoment).format('DD/MM/YYYY') && (moment(newdate).format('HH:mm') < barmen_adv_time_end)) {
                                if (time == null)
                                    time = moment(newdate).format('HH:mm');
                                availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                            }
                        }

                        // new added 

                        if (barmen_time_end) {
                            let durationElement: any = this.selectedBarber.today_advanced_bookings[this.selectedBarber.today_advanced_bookings.length - 1];
                            if (durationElement) {
                                let end = barmen_time_end.split(":");
                                const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                                let newdate = new Date(new Date(new Date(durationElement.requested_booking_time).setSeconds(0)).getTime() + durationElement.getDuration * 60000);
                                let differenceAdv = new Date(endTime).getTime() - new Date(newdate).getTime();
                                differenceAdv = differenceAdv / 60000;
                                if (this.selectedServicesDuration <= Math.ceil(differenceAdv) && moment(newdate).format('DD/MM/YYYY') == moment(nowMoment).format('DD/MM/YYYY') && (moment(newdate).format('HH:mm') < barmen_time_end)) {
                                    if (time == null)
                                        time = moment(newdate).format('HH:mm');

                                    availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                                }
                            }
                        }
                    }

                    for (let index = 0; index < this.selectedBarber.today_advanced_bookings.length; index++) {
                        if (index != (this.selectedBarber.today_advanced_bookings.length - 1)) {
                            let upcomingadv = new Date(this.selectedBarber.today_advanced_bookings[index + 1].requested_booking_time);
                            let newdateAdvc = new Date(new Date(new Date(this.selectedBarber.today_advanced_bookings[index].requested_booking_time)).getTime() + this.selectedBarber.today_advanced_bookings[index].getDuration * 60000);
                            let differenceAdv = new Date(upcomingadv).getTime() - new Date(newdateAdvc).getTime();
                            differenceAdv = differenceAdv / 60000;
                            if (this.selectedServicesDuration <= Math.ceil(differenceAdv)) {
                                if (time == null)
                                    time = moment(newdateAdvc).format('HH:mm');

                                availableSlots.push({ date: moment(newdateAdvc).format('HH:mm'), available: true, booking_type: 1 });
                            }
                        }
                    }
                } else {
                    let durationElement: any = this.selectedBarber.today_advanced_bookings[0];
                    if (durationElement) {
                        if (barmen_adv_time_end) {
                            let end = barmen_adv_time_end.split(":");
                            const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                            let newdate = new Date(new Date(new Date(durationElement.requested_booking_time).setSeconds(0)).getTime() + durationElement.getDuration * 60000);
                            let differenceAdv = new Date(endTime).getTime() - new Date(newdate).getTime();
                            differenceAdv = differenceAdv / 60000;
                            if (this.selectedServicesDuration <= Math.ceil(differenceAdv)) {
                                if (time == null)
                                    time = moment(newdate).format('HH:mm');
                                availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                            }
                        } else {
                            let newdate = new Date(new Date(new Date(durationElement.requested_booking_time).setSeconds(0)).getTime() + durationElement.getDuration * 60000);
                            if (moment(newdate).format('DD/MM/YYYY') == moment(nowMoment).format('DD/MM/YYYY') && (moment(newdate).format('HH:mm') < barmen_adv_time_end)) {
                                if (time == null)
                                    time = moment(newdate).format('HH:mm');
                                availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                            }
                        }
                    }

                    if (barmen_time_end) {
                        let durationElement: any = this.selectedBarber.today_advanced_bookings[this.selectedBarber.today_advanced_bookings.length - 1];
                        if (durationElement) {
                            let end = barmen_time_end.split(":");
                            const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                            let newdate = new Date(new Date(new Date(durationElement.requested_booking_time).setSeconds(0)).getTime() + durationElement.getDuration * 60000);
                            let differenceAdv = new Date(endTime).getTime() - new Date(newdate).getTime();
                            differenceAdv = differenceAdv / 60000;
                            if (this.selectedServicesDuration <= Math.ceil(differenceAdv) && moment(newdate).format('DD/MM/YYYY') == moment(nowMoment).format('DD/MM/YYYY') && (moment(newdate).format('HH:mm') < barmen_time_end)) {
                                if (time == null)
                                    time = moment(newdate).format('HH:mm');

                                availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                            }
                        }
                    }



                }
            }

            if (this.selectedBarber.today_advanced_bookings.length > 0) {
                let lastElement = this.selectedBarber.today_advanced_bookings[this.selectedBarber.today_advanced_bookings.length - 1];
                let currentAdVTime = lastElement.estimated_booking_time ? lastElement.estimated_booking_time : lastElement.requested_booking_time;
                let newdate = new Date(new Date(new Date(currentAdVTime).setSeconds(0)).getTime() + lastElement.getDuration * 60000);
                let end = barmen_adv_time_end.split(":");
                const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                let differenceAdv = new Date(endTime).getTime() - new Date(newdate).getTime();
                differenceAdv = differenceAdv / 60000;
                if (this.selectedServicesDuration <= Math.ceil(differenceAdv)) {
                    if (time == null)
                        time = moment(newdate).format('HH:mm');
                    availableSlots.push({ date: moment(newdate).format('HH:mm'), available: true, booking_type: 1 });
                }
            }
        } else {
            // if (barmen_time_end) {
            //     if (today_time < barmen_time_end) {
            //         time = today_time
            //     } else {
            //         //this.errorMessage = 'Queue is full';
            //         return;
            //     }
            // }

            if (this.coffeShopService.user.hours && this.coffeShopService.user.hours[`${today_day}`]) {
                let todayEndTime = this.coffeShopService.user.hours[`${today_day}`];
                let end = todayEndTime.split(":");
                const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                let differenceAdv = new Date(endTime).getTime() - new Date(nowMoment).getTime();
                differenceAdv = Math.ceil(differenceAdv / 60000);
                if (this.selectedServicesDuration <= Math.ceil(differenceAdv)) {
                    if (time == null)
                        time = today_time;
                    availableSlots.push({ date: today_time, available: true, booking_type: 1 });
                } else {
                    if (!this.coffeShopService.user.isHolidayToday && this.coffeShopService.user.is_available) {
                        if (!this.coffeShopService.bookingDates.find((bookedDate) => bookedDate.date.getTime() === now.getTime())) {
                            this.coffeShopService.bookingDates.unshift({ date: now, available: true });
                            this.coffeShopService.selectedDate = now as any;
                        }
                        this.errorMessage = 'Queue is full';
                        return;
                    }
                }
            } else {
                if (barmen_time_end) {
                    if (today_time < barmen_time_end) {
                        time = today_time;
                        availableSlots.push({ date: today_time, available: true, booking_type: 1 });
                    } else {
                        //this.errorMessage = 'Queue is full';
                        return;
                    }
                }
            }
            if (!barmen_time_end && this.coffeShopService.coffeShop.hours[`${today_day}`]) {
                const shop_hours_start = `${this.coffeShopService.coffeShop.hours[`${today_day}`].split(':')[0]}:${this.coffeShopService.coffeShop.hours[`${today_day}`].split(':')[1]}`;
                const shop_hours_end = `${this.coffeShopService.coffeShop.hours[`${today_day}_close`].split(':')[0]}:${this.coffeShopService.coffeShop.hours[`${today_day}_close`].split(':')[1]}`;
                if (today_time < shop_hours_start) { time = shop_hours_start; }
                if (today_time > shop_hours_start && today_time < shop_hours_end && this.coffeShopService.user.hours[`${today_day}`]) {
                    time = today_time;
                } else {
                    if (today_time > shop_hours_end) {
                        // this.disableContinueButton = true;
                        // this.errorMessage = 'Shop is closed';
                        //return;
                    }
                    if (!this.coffeShopService.user.isHolidayToday && this.coffeShopService.user.is_available) {
                        if (!this.coffeShopService.bookingDates.find((bookedDate) => bookedDate.date.getTime() === now.getTime())) {
                            this.coffeShopService.bookingDates.unshift({ date: now, available: true });
                            this.coffeShopService.selectedDate = now as any;
                        }
                        // this.errorMessage = 'Barber not available';
                    }
                    if (this.coffeShopService.bookingTimes.length == 0 && this.coffeShopService.user.is_available) {
                        this.coffeShopService.bookingTimes.push({ date: today_time, available: true });
                        this.coffeShopService.selectedTime = today_time;
                    }
                    if (moment(this.coffeShopService.selectedDate).format('DD/MM/YYYY') == moment().format('DD/MM/YYYY') && !this.coffeShopService.user.is_available) {
                        this.errorMessage = 'Barber not available';
                    }
                    // this.isContinue = true;
                }
                if (today_time > shop_hours_end) {
                    //   this.disableContinueButton = true;
                    // this.errorMessage = 'Shop is closed';
                    return;
                }
            }
        }

        if (time) {
            let nowMoment = this.convertTZ(new Date(), this.coffeShopService.coffeShop.timezone.timezone);
            if (this.coffeShopService.user.advanced_booking_hours && this.coffeShopService.user.advanced_booking_hours[`${today_day}`]) {
                if (this.coffeShopService.bookingTimes.length && this.coffeShopService.bookingTimes[0].date === time && availableSlots.length == 0) {
                    this.coffeShopService.bookingTimes[0].booking_type = 1;
                } else {
                    // this.coffeShopService.bookingTimes.unshift({ date: time, available: true, booking_type: 1 });
                    if (this.coffeShopService.user.hours && this.coffeShopService.user.hours[`${today_day}`]) {
                        let todayStartTime = this.coffeShopService.user.hours[`${today_day}_start`];
                        let todayEndTime = this.coffeShopService.user.hours[`${today_day}`];
                        let start = todayStartTime.split(":")
                        let end = todayEndTime.split(":");
                        const startTime = new Date(nowMoment).setHours(Number(start[0]), Number(start[1]));
                        const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                        if (new Date(startTime).getTime() <= nowMoment.getTime() && new Date(endTime).getTime() >= nowMoment.getTime()) {
                            this.coffeShopService.selectedTime = time;
                            if (availableSlots.length > 0) {
                                this.coffeShopService.bookingTimes = [...availableSlots, ...this.coffeShopService.bookingTimes];
                                this.coffeShopService.bookingTimes = this.coffeShopService.bookingTimes.sort((a, b) => a.date.localeCompare(b.date));
                            } else {
                                this.coffeShopService.bookingTimes.unshift({ date: time, available: true, booking_type: 1 });
                            }

                        } else {
                            this.coffeShopService.selectedTime = this.coffeShopService.bookingTimes.length > 0 ? this.coffeShopService.bookingTimes[0].date : null;
                        }
                    }
                }
                // this.coffeShopService.selectedTime = time;
                this.coffeShopService.bookingType = 1;
                if (!this.coffeShopService.bookingDates.find((bookedDate) => bookedDate.date.getTime() === now.getTime()) && (this.coffeShopService.user && !this.coffeShopService.user.isHolidayToday && this.coffeShopService.user.is_available)) {
                    this.coffeShopService.bookingDates.unshift({ date: now, available: true });
                    this.coffeShopService.selectedDate = now as any;
                }
                this.coffeShopService.bookingTimes = this.removeDuplicates(this.coffeShopService.bookingTimes);
                this.coffeShopService.selectedTime = this.coffeShopService.bookingTimes[0].date;
                return;
            }

            if (((!this.coffeShopService.user.advanced_booking_hours || !this.coffeShopService.user.advanced_booking_hours[`${today_day}`]) &&
                this.coffeShopService.user.hours[`${today_day}_start`]) || this.coffeShopService.coffeShop.hours[`${today_day}`]) {
                this.coffeShopService.bookingTimes = [];

                this.coffeShopService.bookingTimes.unshift({ date: time, available: true, booking_type: 1 });
                this.coffeShopService.selectedTime = time;
                this.coffeShopService.bookingType = 1;
                if (availableSlots.length > 0) {
                    this.coffeShopService.bookingTimes = [...availableSlots, ...this.coffeShopService.bookingTimes];
                    this.coffeShopService.bookingTimes = this.coffeShopService.bookingTimes.sort((a, b) => a.date.localeCompare(b.date));
                }
                if (!this.coffeShopService.bookingDates.find((bookedDate) => bookedDate.date.getTime() === now.getTime()) && (this.coffeShopService.user && !this.coffeShopService.user.isHolidayToday && this.coffeShopService.user.is_available)) {
                    this.coffeShopService.bookingDates.unshift({ date: now, available: true });
                    this.coffeShopService.selectedDate = now as any;
                }
                this.coffeShopService.bookingTimes = this.removeDuplicates(this.coffeShopService.bookingTimes);
                this.coffeShopService.selectedTime = this.coffeShopService.bookingTimes[0].date;
            }
        } else {
            if (this.coffeShopService.user.hours && this.coffeShopService.user.hours[`${today_day}`] &&
                (this.coffeShopService.user.advanced_booking_hours && (typeof (this.coffeShopService.user.advanced_booking_hours[`${today_day}`]) == "undefined" || this.coffeShopService.user.advanced_booking_hours[`${today_day}`] == null))) {
                let todayStartTime = this.coffeShopService.user.hours[`${today_day}_start`];
                let todayEndTime = this.coffeShopService.user.hours[`${today_day}`];
                let start = todayStartTime.split(":")
                let end = todayEndTime.split(":");
                const startTime = new Date(nowMoment).setHours(Number(start[0]), Number(start[1]));
                const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                if (new Date(startTime).getTime() <= nowMoment.getTime() && new Date(endTime).getTime() >= nowMoment.getTime()) {
                    this.coffeShopService.bookingTimes = [];
                    if (!this.coffeShopService.bookingDates.find((bookedDate) => bookedDate.date.getTime() === now.getTime()) && (this.coffeShopService.user && !this.coffeShopService.user.isHolidayToday && this.coffeShopService.user.is_available)) {
                        this.coffeShopService.bookingDates.unshift({ date: now, available: true });
                        this.coffeShopService.selectedDate = now as any;
                    }
                }
            } else if (this.coffeShopService.user.hours && this.coffeShopService.user.hours[`${today_day}`]) {
                let todayStartTime = this.coffeShopService.user.hours[`${today_day}_start`];
                let todayEndTime = this.coffeShopService.user.hours[`${today_day}`];
                let start = todayStartTime.split(":")
                let end = todayEndTime.split(":");
                const startTime = new Date(nowMoment).setHours(Number(start[0]), Number(start[1]));
                const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
                if (new Date(startTime).getTime() <= nowMoment.getTime() && new Date(endTime).getTime() >= nowMoment.getTime() && !this.coffeShopService.user.isHolidayToday && this.coffeShopService.user.is_available) {
                    if (!this.coffeShopService.bookingDates.find((bookedDate) => bookedDate.date.getTime() === now.getTime())) {
                        this.coffeShopService.bookingDates.unshift({ date: now, available: true });
                    }
                }
            }
        }
    }

    isBarberQueueFull(barber) {
        return this.staffService.isStaffQueueFull(barber, this.coffeShopService.coffeShop.id);
    }

    removeDuplicates(bookings: any[]) {
        const uniqueBookings = bookings.reduce((accumulator: any, booking: any) => {
            const existingBooking = accumulator.find(
                (item) => item.date === booking.date && item.available === booking.available
            );

            if (!existingBooking) {
                accumulator.push(booking);
            }

            return accumulator;
        }, []);

        return uniqueBookings;
    }

    //26/05/2023
    // public checkBarberIsFree(): void {
    //     const now = new Date(new Date(new Date(new Date(new Date(new Date(new Date().toLocaleString("en-US", { timeZone: this.coffeShopService.coffeShop.timezone.timezone })).setHours(0)).setMinutes(0)).setSeconds(0))).setMilliseconds(0));
    //     const timezoen = new Date(new Date().toLocaleString("en-US", { timeZone: this.coffeShopService.coffeShop.timezone.timezone }));
    //     const today_time = `${timezoen.getHours() >= 10 ? timezoen.getHours() : `0` + timezoen.getHours()}:${timezoen.getMinutes() >= 10 ? timezoen.getMinutes() : `0` + timezoen.getMinutes()}`
    //     const today_day = moment(timezoen).format('dddd').toLocaleLowerCase();
    //     const barmen_time_end = this.coffeShopService.user.hours[`${today_day}`] ?
    //         `${this.coffeShopService.user.hours[`${today_day}`].split(':')[0]}:${this.coffeShopService.user.hours[`${today_day}`].split(':')[1]}` : null;
    //     const barmen_has_andvanced_booking = !!this.coffeShopService.user.advanced_booking_hours;
    //     if (!barmen_has_andvanced_booking && !barmen_time_end && !this.coffeShopService.coffeShop.hours[`${today_day}`]) {
    //         //   this.disableContinueButton = true;
    //         this.errorMessage = 'Queue is full';
    //         return;
    //     }
    //     let time = null;
    //     if (this.coffeShopService.user && this.coffeShopService.user.current_queue_length > 0) {
    //         this.coffeShopService.user.current_chair_time_with_cancelled = this.coffeShopService.user.current_chair_time_with_cancelled.toUpperCase();
    //         if (this.selectedBarber.todays_cancelled_bookings.length == 0 && this.selectedBarber.today_advanced_bookings.length == 0) {
    //             time = this.coffeShopService.user.current_chair_time_with_cancelled.includes('AM') ?
    //                 this.coffeShopService.convert12to24(this.coffeShopService.user.current_chair_time_with_cancelled.split('AM').join(' AM')) :
    //                 this.coffeShopService.convert12to24(this.coffeShopService.user.current_chair_time_with_cancelled.split('PM').join(' PM'));
    //             // } else if (this.todayCancelledBooking && !this.selectedBarber.today_advanced_bookings) {
    //         } else if (this.todayCancelledBooking.length > 0 && this.selectedBarber.today_advanced_bookings.length == 0) {
    //             for (var item of this.todayCancelledBooking) {
    //                 if (this.selectedServicesDuration <= item.available_duration) {
    //                     time = item.estimated_chair_time_string.toString().toUpperCase().includes('AM') ?
    //                         this.coffeShopService.convert12to24(item.estimated_chair_time_string.toString().toUpperCase().split('AM').join(' AM')) :
    //                         this.coffeShopService.convert12to24(item.estimated_chair_time_string.toString().toUpperCase().split('PM').join(' PM'));
    //                     break;
    //                 }
    //                 // time = today_time;
    //             }

    //         } else if (this.todayBooking.length > 0 && this.selectedBarber.today_advanced_bookings.length > 0) {
    //             // for (var element of this.todayCancelledBooking) {
    //             //     if (this.selectedServicesDuration <= element.available_duration) {
    //             //         time = element.estimated_chair_time_string.toString().toUpperCase().includes('AM') ?
    //             //             this.coffeShopService.convert12to24(element.estimated_chair_time_string.toString().toUpperCase().split('AM').join(' AM')) :
    //             //             this.coffeShopService.convert12to24(element.estimated_chair_time_string.toString().toUpperCase().split('PM').join(' PM'));
    //             //         break;
    //             //     }
    //             //     // time = today_time;
    //             // }

    //             for (var element of this.todayCancelledBooking) {
    //                 if (this.selectedServicesDuration <= element.available_duration) {
    //                     time = element.estimated_chair_time_string.toString().toUpperCase().includes('AM') ?
    //                         this.coffeShopService.convert12to24(element.estimated_chair_time_string.toString().toUpperCase().split('AM').join(' AM')) :
    //                         this.coffeShopService.convert12to24(element.estimated_chair_time_string.toString().toUpperCase().split('PM').join(' PM'));
    //                     break;
    //                 }

    //                 // time = today_time;
    //             }

    //             if (time == null && this.todayBooking[this.todayBooking.length - 1] && this.selectedBarber.today_advanced_bookings[0]) {
    //                 let todayAdvanceBookings = this.selectedBarber.today_advanced_bookings.filter(res => res.requested_booking_time && res.estimated_booking_time == null);
    //                 let estimated_booking_time = this.selectedBarber.todays_booking[this.selectedBarber.todays_booking.length - 1].estimated_booking_time;
    //                 let requested_booking_time = todayAdvanceBookings.length > 0 ? todayAdvanceBookings[0].requested_booking_time : '';
    //                 let durationElement: any = this.todayBooking.filter(res => res.id == this.selectedBarber.todays_booking[this.selectedBarber.todays_booking.length - 1].id)[0];
    //                 let newdate = new Date(new Date(new Date(estimated_booking_time)).getTime() + durationElement.available_duration * 60000);
    //                 let difference = new Date(requested_booking_time).getTime() - new Date(newdate).getTime();
    //                 difference = difference / 60000;
    //                 if (this.selectedServicesDuration <= Math.ceil(difference)) {
    //                     time = moment(newdate).format('HH:mm');
    //                 } else {
    //                     // let adv_estimated_booking_time = this.selectedBarber.today_advanced_bookings[this.selectedBarber.today_advanced_bookings.length - 1].requested_booking_time;
    //                     let adv_estimated_booking_time = this.selectedBarber.today_advanced_bookings[this.selectedBarber.today_advanced_bookings.length - 1].estimated_booking_time ?
    //                         this.selectedBarber.today_advanced_bookings[this.selectedBarber.today_advanced_bookings.length - 1].estimated_booking_time :
    //                         this.selectedBarber.today_advanced_bookings[this.selectedBarber.today_advanced_bookings.length - 1].requested_booking_time;

    //                     let adv_cancel_newdate = new Date(new Date(new Date(adv_estimated_booking_time)).getTime() + this.selectedBarber.today_advanced_bookings[this.selectedBarber.today_advanced_bookings.length - 1].getDuration * 60000);
    //                     time = moment(adv_cancel_newdate).format('HH:mm');

    //                     // for (let index = 0; index < this.selectedBarber.today_advanced_bookings.length; index++) {
    //                     //     if (index != (this.selectedBarber.today_advanced_bookings.length - 1)) {
    //                     //         let upcomingadv = new Date(this.selectedBarber.today_advanced_bookings[index + 1].requested_booking_time);
    //                     //         let newdateAdvc = new Date(new Date(new Date(this.selectedBarber.today_advanced_bookings[index].requested_booking_time)).getTime() + this.selectedBarber.today_advanced_bookings[index].getDuration * 60000);
    //                     //         let differenceAdv = new Date(upcomingadv).getTime() - new Date(newdateAdvc).getTime();
    //                     //         differenceAdv = differenceAdv / 60000;
    //                     //         if (this.selectedServicesDuration <= differenceAdv) {
    //                     //             time = moment(newdateAdvc).format('HH:mm');
    //                     //             break;
    //                     //         }
    //                     //     }
    //                     // }

    //                     for (let index = 0; index < this.selectedBarber.today_advanced_bookings.length; index++) {
    //                         if (index != (this.selectedBarber.today_advanced_bookings.length - 1)) {
    //                             let upcomingadv = this.selectedBarber.today_advanced_bookings[index + 1].estimated_booking_time ? new Date(this.selectedBarber.today_advanced_bookings[index + 1].estimated_booking_time) : new Date(this.selectedBarber.today_advanced_bookings[index + 1].requested_booking_time);

    //                             let currentAdVTime = this.selectedBarber.today_advanced_bookings[index].estimated_booking_time ? this.selectedBarber.today_advanced_bookings[index].estimated_booking_time : this.selectedBarber.today_advanced_bookings[index].requested_booking_time;

    //                             let newdateAdvc = new Date(new Date(new Date(currentAdVTime)).getTime() + this.selectedBarber.today_advanced_bookings[index].getDuration * 60000);
    //                             let differenceAdv = new Date(upcomingadv).getTime() - new Date(newdateAdvc).getTime();
    //                             differenceAdv = differenceAdv / 60000;
    //                             if (this.selectedServicesDuration <= Math.ceil(differenceAdv)) {
    //                                 time = moment(newdateAdvc).format('HH:mm');
    //                                 break;
    //                             }
    //                         }
    //                     }
    //                 }
    //             }

    //         } else {
    //             let cancel_estimated_booking_time = this.selectedBarber.todays_booking[this.selectedBarber.todays_booking.length - 1].estimated_booking_time;
    //             let cancel_durationElement: any = this.todayBooking.filter(res => res.id == this.selectedBarber.todays_booking[this.selectedBarber.todays_booking.length - 1].id)[0];
    //             let cancel_newdate = new Date(new Date(new Date(cancel_estimated_booking_time)).getTime() + cancel_durationElement.available_duration * 60000);
    //             time = moment(cancel_newdate).format('HH:mm');
    //         }
    //     } else if (this.coffeShopService.user && this.coffeShopService.user.current_queue_length <= 0) {

    //         if (typeof (this.selectedBarber.today_advanced_bookings) != "undefined"
    //             && this.selectedBarber.today_advanced_bookings != null
    //             && this.selectedBarber.today_advanced_bookings.length > 1) {
    //             for (let index = 0; index < this.selectedBarber.today_advanced_bookings.length; index++) {
    //                 if (index != (this.selectedBarber.today_advanced_bookings.length - 1)) {
    //                     let upcomingadv = new Date(this.selectedBarber.today_advanced_bookings[index + 1].requested_booking_time);
    //                     let newdateAdvc = new Date(new Date(new Date(this.selectedBarber.today_advanced_bookings[index].requested_booking_time)).getTime() + this.selectedBarber.today_advanced_bookings[index].getDuration * 60000);
    //                     if (new Date(newdateAdvc).getTime() > new Date().getTime()) {
    //                         time = today_time;
    //                         break;
    //                     }

    //                     let differenceAdv = new Date(upcomingadv).getTime() - new Date(newdateAdvc).getTime();
    //                     differenceAdv = differenceAdv / 60000;
    //                     if (this.selectedServicesDuration <= differenceAdv) {
    //                         time = moment(newdateAdvc).format('HH:mm');
    //                         break;
    //                     }
    //                 }
    //             }
    //         } else {
    //             if (barmen_time_end) {
    //                 if (today_time < barmen_time_end) {
    //                     time = today_time
    //                 } else {
    //                     //this.errorMessage = 'Queue is full';
    //                     return;
    //                 }
    //             }
    //             if (!barmen_time_end && this.coffeShopService.coffeShop.hours[`${today_day}`]) {
    //                 const shop_hours_start = `${this.coffeShopService.coffeShop.hours[`${today_day}`].split(':')[0]}:${this.coffeShopService.coffeShop.hours[`${today_day}`].split(':')[1]}`;
    //                 const shop_hours_end = `${this.coffeShopService.coffeShop.hours[`${today_day}_close`].split(':')[0]}:${this.coffeShopService.coffeShop.hours[`${today_day}_close`].split(':')[1]}`;
    //                 if (today_time < shop_hours_start) { time = shop_hours_start; }
    //                 if (today_time > shop_hours_start && today_time < shop_hours_end && this.coffeShopService.user.hours[`${today_day}`]) {
    //                     time = today_time;
    //                 } else {
    //                     if (today_time > shop_hours_end) {
    //                         // this.disableContinueButton = true;
    //                         // this.errorMessage = 'Shop is closed';
    //                         return;
    //                     }
    //                     if (!this.coffeShopService.bookingDates.find((bookedDate) => bookedDate.date.getTime() === now.getTime())) {
    //                         this.coffeShopService.bookingDates.unshift({ date: now, available: true });
    //                         this.coffeShopService.selectedDate = now as any;
    //                     }
    //                     this.errorMessage = 'Barber not available';
    //                     // this.isContinue = true;

    //                 }
    //                 if (today_time > shop_hours_end) {
    //                     //   this.disableContinueButton = true;
    //                     // this.errorMessage = 'Shop is closed';
    //                     return;
    //                 }
    //             }
    //         }
    //     }
    //     if (time) {
    //         let nowMoment = this.convertTZ(new Date(), this.coffeShopService.coffeShop.timezone.timezone);
    //         if (this.coffeShopService.user.advanced_booking_hours && this.coffeShopService.user.advanced_booking_hours[`${today_day}`]) {
    //             if (this.coffeShopService.bookingTimes.length && this.coffeShopService.bookingTimes[0].date === time) {
    //                 this.coffeShopService.bookingTimes[0].booking_type = 1;
    //             } else {
    //                 // this.coffeShopService.bookingTimes.unshift({ date: time, available: true, booking_type: 1 });
    //                 if (this.coffeShopService.user.hours && this.coffeShopService.user.hours[`${today_day}`]) {
    //                     let todayStartTime = this.coffeShopService.user.hours[`${today_day}_start`];
    //                     let todayEndTime = this.coffeShopService.user.hours[`${today_day}`];
    //                     let start = todayStartTime.split(":")
    //                     let end = todayEndTime.split(":");
    //                     const startTime = new Date(nowMoment).setHours(Number(start[0]), Number(start[1]));
    //                     const endTime = new Date(nowMoment).setHours(Number(end[0]), Number(end[1]));
    //                     // if (new Date(startTime).getTime() <= nowMoment.getTime() && new Date(endTime).getTime() >= nowMoment.getTime()) {
    //                     //     this.coffeShopService.selectedTime = time;
    //                     //     this.coffeShopService.bookingTimes.unshift({ date: time, available: true, booking_type: 1 });
    //                     // } else {
    //                     //     this.coffeShopService.selectedTime = this.coffeShopService.bookingTimes.length > 0 ? this.coffeShopService.bookingTimes[0].date : null;
    //                     // }

    //                     if (new Date(startTime).getTime() <= nowMoment.getTime() && new Date(endTime).getTime() >= nowMoment.getTime()) {
    //                         //   let currentTime = time.split(":")
    //                         //   if (currentTime[1] >= 59) {
    //                         //     currentTime[0] = Number(currentTime[0]) + 1;
    //                         //     currentTime[1] = "00";
    //                         //   } else {
    //                         //     currentTime[1] = Number(currentTime[1]) + 1;
    //                         //   }
    //                         //   time = currentTime[0] + ":" + (currentTime[1].toString().length == 1 ? '0' + currentTime[1].toString() : currentTime[1].toString());
    //                         this.coffeShopService.selectedTime = time;

    //                         this.coffeShopService.bookingTimes.unshift({ date: time, available: true, booking_type: 1 });
    //                     } else {
    //                         this.coffeShopService.selectedTime = this.coffeShopService.bookingTimes.length > 0 ? this.coffeShopService.bookingTimes[0].date : null;
    //                     }
    //                 }
    //             }
    //             // this.coffeShopService.selectedTime = time;
    //             this.coffeShopService.bookingType = 1;
    //             if (!this.coffeShopService.bookingDates.find((bookedDate) => bookedDate.date.getTime() === now.getTime())) {
    //                 this.coffeShopService.bookingDates.unshift({ date: now, available: true });
    //                 this.coffeShopService.selectedDate = now as any;
    //             }
    //             return;
    //         }

    //         if (((!this.coffeShopService.user.advanced_booking_hours || !this.coffeShopService.user.advanced_booking_hours[`${today_day}`]) &&
    //             this.coffeShopService.user.hours[`${today_day}_start`]) || this.coffeShopService.coffeShop.hours[`${today_day}`]) {

    //             this.coffeShopService.bookingTimes = [];
    //             this.coffeShopService.bookingTimes.unshift({ date: time, available: true, booking_type: 1 });
    //             this.coffeShopService.selectedTime = time;
    //             this.coffeShopService.bookingType = 1;
    //             if (!this.coffeShopService.bookingDates.find((bookedDate) => bookedDate.date.getTime() === now.getTime())) {
    //                 this.coffeShopService.bookingDates.unshift({ date: now, available: true });
    //                 this.coffeShopService.selectedDate = now as any;
    //             }
    //         }
    //     }
    // }


    //OLD
    // public checkBarberIsFree(): void {
    //     const now = new Date(new Date(new Date(new Date(new Date(new Date(new Date().toLocaleString("en-US", { timeZone: this.coffeShopService.coffeShop.timezone.timezone })).setHours(0)).setMinutes(0)).setSeconds(0))).setMilliseconds(0));
    //     const timezoen = new Date(new Date().toLocaleString("en-US", { timeZone: this.coffeShopService.coffeShop.timezone.timezone }));
    //     const today_time = `${timezoen.getHours() >= 10 ? timezoen.getHours() : `0` + timezoen.getHours()}:${timezoen.getMinutes() >= 10 ? timezoen.getMinutes() : `0` + timezoen.getMinutes()}`
    //     const today_day = moment(timezoen).format('dddd').toLocaleLowerCase();
    //     const barmen_time_end = this.coffeShopService.user.hours[`${today_day}`] ?
    //         `${this.coffeShopService.user.hours[`${today_day}`].split(':')[0]}:${this.coffeShopService.user.hours[`${today_day}`].split(':')[1]}` : null;
    //     const barmen_has_andvanced_booking = !!this.coffeShopService.user.advanced_booking_hours;
    //     if (!barmen_has_andvanced_booking && !barmen_time_end && !this.coffeShopService.coffeShop.hours[`${today_day}`]) {
    //         //   this.disableContinueButton = true;
    //         this.errorMessage = 'Queue is full';
    //         return;
    //     }
    //     let time = null;
    //     if (this.coffeShopService.user && this.coffeShopService.user.current_queue_length > 0) {
    //         this.coffeShopService.user.current_chair_time_with_cancelled = this.coffeShopService.user.current_chair_time_with_cancelled.toUpperCase();
    //         time = this.coffeShopService.user.current_chair_time_with_cancelled.includes('AM') ?
    //             this.coffeShopService.convert12to24(this.coffeShopService.user.current_chair_time_with_cancelled.split('AM').join(' AM')) :
    //             this.coffeShopService.convert12to24(this.coffeShopService.user.current_chair_time_with_cancelled.split('PM').join(' PM'));
    //     } else if (this.coffeShopService.user && this.coffeShopService.user.current_queue_length <= 0) {
    //         if (barmen_time_end) {
    //             if (today_time < barmen_time_end) {
    //                 time = today_time
    //             } else {
    //                 //this.errorMessage = 'Queue is full';
    //                 return;
    //             }
    //         }
    //         if (!barmen_time_end && this.coffeShopService.coffeShop.hours[`${today_day}`]) {
    //             const shop_hours_start = `${this.coffeShopService.coffeShop.hours[`${today_day}`].split(':')[0]}:${this.coffeShopService.coffeShop.hours[`${today_day}`].split(':')[1]}`;
    //             const shop_hours_end = `${this.coffeShopService.coffeShop.hours[`${today_day}_close`].split(':')[0]}:${this.coffeShopService.coffeShop.hours[`${today_day}_close`].split(':')[1]}`;
    //             if (today_time < shop_hours_start) { time = shop_hours_start; }
    //             if (today_time > shop_hours_start && today_time < shop_hours_end && this.coffeShopService.user.hours[`${today_day}`]) {
    //                 time = today_time;
    //             } else {
    //                 if (today_time > shop_hours_end) {
    //                     // this.disableContinueButton = true;
    //                     // this.errorMessage = 'Shop is closed';
    //                     return;
    //                 }
    //                 if (!this.coffeShopService.bookingDates.find((bookedDate) => bookedDate.date.getTime() === now.getTime())) {
    //                     this.coffeShopService.bookingDates.unshift({ date: now, available: true });
    //                     this.coffeShopService.selectedDate = now as any;
    //                 }
    //                 this.errorMessage = 'Barber not available';
    //                 this.disableContinueButton = true;

    //             }
    //             if (today_time > shop_hours_end) {
    //                 //   this.disableContinueButton = true;
    //                 // this.errorMessage = 'Shop is closed';
    //                 return;
    //             }
    //         }
    //     }
    //     if (time) {
    //         if (this.coffeShopService.user.advanced_booking_hours && this.coffeShopService.user.advanced_booking_hours[`${today_day}`]) {
    //             if (this.coffeShopService.bookingTimes.length && this.coffeShopService.bookingTimes[0].date === time) {
    //                 this.coffeShopService.bookingTimes[0].booking_type = 1;
    //             } else {
    //                 let nowMoment = this.convertTZ(new Date(), this.coffeShopService.coffeShop.timezone.timezone);
    //                 // this.coffeShopService.bookingTimes.unshift({ date: time, available: true, booking_type: 1 });
    //                 if (this.coffeShopService.user.hours && this.coffeShopService.user.hours[`${today_day}`]) {
    //                     let todayStartTime = this.coffeShopService.user.hours[`${today_day}_start`];
    //                     let todayEndTime = this.coffeShopService.user.hours[`${today_day}`];
    //                     let start = todayStartTime.split(":")
    //                     let end = todayEndTime.split(":");
    //                     const startTime = new Date().setHours(Number(start[0]), Number(start[1]));
    //                     const endTime = new Date().setHours(Number(end[0]), Number(end[1]));
    //                     if (new Date(startTime).getTime() <= nowMoment.getTime() && new Date(endTime).getTime() >= nowMoment.getTime()) {
    //                         this.coffeShopService.selectedTime = time;
    //                         this.coffeShopService.bookingTimes.unshift({ date: time, available: true, booking_type: 1 });
    //                     } else {
    //                         this.coffeShopService.selectedTime = this.coffeShopService.bookingTimes ? this.coffeShopService.bookingTimes[0].date : null;
    //                     }
    //                 }
    //             }
    //             // this.coffeShopService.selectedTime = time;
    //             this.coffeShopService.bookingType = 1;
    //             if (!this.coffeShopService.bookingDates.find((bookedDate) => bookedDate.date.getTime() === now.getTime())) {
    //                 this.coffeShopService.bookingDates.unshift({ date: now, available: true });
    //                 this.coffeShopService.selectedDate = now as any;
    //             }
    //             return;
    //         }
    //         if (((!this.coffeShopService.user.advanced_booking_hours || !this.coffeShopService.user.advanced_booking_hours[`${today_day}`]) &&
    //             this.coffeShopService.user.hours[`${today_day}_start`]) || this.coffeShopService.coffeShop.hours[`${today_day}`]) {
    //             this.coffeShopService.bookingTimes = [];
    //             this.coffeShopService.bookingTimes.unshift({ date: time, available: true, booking_type: 1 });
    //             this.coffeShopService.selectedTime = time;
    //             this.coffeShopService.bookingType = 1;
    //             if (!this.coffeShopService.bookingDates.find((bookedDate) => bookedDate.date.getTime() === now.getTime())) {
    //                 this.coffeShopService.bookingDates.unshift({ date: now, available: true });
    //                 this.coffeShopService.selectedDate = now as any;
    //             }
    //         }
    //     }
    // }

    openCalendar() {

        let disableWeeks = [0, 1, 2, 3, 4, 5, 6];
        let enabledDays: any = [];
        const barbersData = [];
        const allHolidays = [];
        let selectedBarber: any;

        if (!this.isFromQueue) {
            // selectedBarber = this.coffeShopService.allBarbers.filter((barber) => barber.id == this.booking.staff_member.user.id)[0];
            selectedBarber = this.coffeShopService.coffeShop.users.filter((barber) => barber.id == this.booking.staff_member.user.id)[0];
        }

        if (this.coffeShopService.allBarbers != null && this.coffeShopService.allBarbers.length > 0) {
            const findIndesx = this.coffeShopService.allBarbers.findIndex((barber) => barber.id == this.selectedBarber.id);
            if (findIndesx !== -1 && (selectedBarber != null)) {
                selectedBarber.holiday = this.coffeShopService.allBarbers[findIndesx].holiday;
                this.selectedBarber.holiday = this.coffeShopService.allBarbers[findIndesx].holiday;
            }
        }

        let holidays = this.coffeShopService.daysConfig(this.isFromQueue ? this.selectedBarber : selectedBarber);
        let enabledDaysInAWeek = this.coffeShopService.enabledDaysInAWeek(this.isFromQueue ? this.selectedBarber : selectedBarber);

        barbersData.push({
            holidays: holidays.map(i => i.date),
            enabledWeekdays: enabledDaysInAWeek,
        });
        for (const h of holidays) {
            if (!allHolidays.find(i => i.date.getTime() === h.date.getTime())) {
                allHolidays.push(h);
            }
        }

        enabledDaysInAWeek.forEach((day, index) => {
            enabledDays.push(day);
        });
        // });

        const allTeamHolidays = [];
        for (const h of allHolidays) {
            const anyBarberAvailable = barbersData.find(i => this.isWorkingDay(i, h.date));
            if (!anyBarberAvailable) allTeamHolidays.push(h)
        }

        let options = this.coffeShopService.options();

        // Remove enabled days from the days to disable in the calendar
        enabledDays.forEach((day) => {
            // @ts-ignore
            if (disableWeeks.includes(day)) {
                let index = disableWeeks.indexOf(day);
                if (index !== -1) disableWeeks.splice(index, 1);
            }
        });
        const lastday: Date = options.to;
        let today: Date = options.from;
        const dates = [];
        while (today.getTime() <= lastday.getTime()) {
            const available = enabledDays.includes(today.getDay());
            dates.push({ date: today, available });
            today = new Date(today.getTime() + 86400000)
        }

        allTeamHolidays.forEach(element => {
            let index = dates.findIndex(item => moment(item.date).format('DD/MM/YYYY') == moment(element.date).format('DD/MM/YYYY'));
            if (index !== -1)
                dates[index].available = false;
        });

        const timezoen = new Date(new Date().toLocaleString("en-US", { timeZone: this.coffeShopService.coffeShop.timezone.timezone }));
        let currentDay = moment(new Date()).format('dddd').toLowerCase();
        console.log({ 'timezoen': moment(timezoen).format('HH:mm:ss'), 'currentDay': this.coffeShopService.coffeShop.hours[currentDay] });
        if ((!this.selectedBarber.is_available && (this.selectedBarber.advanced_booking_hours && this.selectedBarber.advanced_booking_hours[currentDay]== null)) && (this.coffeShopService.coffeShop.hours[currentDay] && moment(timezoen).format('HH:mm:ss') > this.coffeShopService.coffeShop.hours[currentDay])) {

            // if(!this.selectedBarber.is_available){
            let index = dates.findIndex(item => moment(item.date).format('DD/MM/YYYY') == moment().format('DD/MM/YYYY'));
            if (index !== -1)
                dates[index].available = false;
        } else {
            if (this.selectedBarber.hours[currentDay] || this.selectedBarber.is_available) {
                let index = dates.findIndex(item => moment(item.date).format('DD/MM/YYYY') == moment().format('DD/MM/YYYY'));
                if (index !== -1) {
                    dates[index].available = true;
                } else {
                    const now = new Date(new Date(new Date(new Date(new Date(new Date(new Date().toLocaleString("en-US", { timeZone: this.coffeShopService.coffeShop.timezone.timezone })).setHours(0)).setMinutes(0)).setSeconds(0))).setMilliseconds(0));
                    //   dates.push({ date: today, available : true });
                    dates.push({ date: new Date(now), available: true });
                }
            }
        }
        this.coffeShopService.bookingDates = dates.filter((date) => date.available);
    }

    isWorkingDay(barberData, date) {
        const weekday = date.getDay();
        if (!barberData.enabledWeekdays.find(i => i === weekday)) {
            return false;
        }

        return !barberData.holidays.find(i => i.getTime() === date.getTime())
    }

    public dateIsEqual(date1: Date, date2: Date): boolean {
        date1 = new Date(date1); date2 = new Date(date2);
        return date1.getTime() === date2.getTime();
    }

    closeModal() {
        this.viewCtrl.dismiss();
    }

    filterBarbersByAvailability(booking: { date: string, available: boolean }): Promise<boolean | HttpErrorResponse> {
        this.disableContinueButton = false;
        const now = new Date(new Date(new Date(new Date(new Date(new Date(new Date().toLocaleString("en-US", { timeZone: this.coffeShopService.coffeShop.timezone.timezone })).setHours(0)).setMinutes(0)).setSeconds(0))).setMilliseconds(0));
        if (booking.available === false || this.timeLoading || this.dateIsEqual((this.coffeShopService.selectedDate as any), (booking.date as any))) {
            return;
        }
        if (booking.date === this.coffeShopService.selectedDate && booking.date !== '') {
            this.coffeShopService.selectedDate = '';
            this.coffeShopService.selectedTime = '';
            return;
        }
        if (booking.date) {
            this.timeLoading = true;
            this.coffeShopService.selectedDate = booking.date;
            this.coffeShopService.bookingTimes = [];
            this.coffeShopService.selectedTime = '';
            this.errorMessage = '';
        }

        const formattedDate = booking.date ? this.coffeShopService.requestDateFormatter(booking.date) : booking.date;
        this.coffeShopService.advancedBookingRequest(booking, true)
            .pipe(concatMap((barbers: any) => {
                if (booking.date !== '') {
                    return forkJoin([of(barbers), this.coffeShopService.getAvailableBookingTimes(formattedDate, this.selectedBarber)])
                } else {
                    return forkJoin([of(barbers), of(null)])
                }
            }))
            .subscribe(async ([barbers, times]: any) => {
                this.coffeShopService.bookingType = null;
                const timezoen = new Date(new Date().toLocaleString("en-US", { timeZone: this.coffeShopService.coffeShop.timezone.timezone }));
                if (times == null) {
                    times = [];
                }

                if (times && times.length > 0) {
                    for (let Tindex = 0; Tindex < times.length; Tindex++) {
                        const element = times[Tindex];

                        if (element.available && times[times.length - 1] !== element) {
                            let duration = element.time_difference_in_minutes;

                            for (let index = Tindex + 1; index < times.length; index++) {
                                if (times[index].available) {
                                    duration += times[index].time_difference_in_minutes;
                                } else {
                                    break;
                                }
                            }

                            element.available = duration >= this.selectedServicesDuration;
                        } else if (times[times.length - 1] === element && element.available == true) {
                            element.available = element.time_difference_in_minutes >= this.selectedServicesDuration;
                        }
                    }
                }
                // try {
                //     await this.getBarberWithBookings().then(
                //         (res: any) => {
                //             this.advanceBookings = res;
                //             if (this.advanceBookings && this.advanceBookings.length > 0) {
                //                 this.advanceBookings = this.advanceBookings.sort((a: any, b: any) => {
                //                     return new Date(a.booking.requested_booking_time).getTime() - new Date(b.booking.requested_booking_time).getTime();
                //                 });

                //                 for (let index = 0; index < this.advanceBookings.length; index++) {
                //                     if (index != (this.advanceBookings.length - 1)) {
                //                         let upcomingadv = this.advanceBookings[index + 1].booking.estimated_booking_time ? new Date(this.advanceBookings[index + 1].booking.estimated_booking_time) : new Date(this.advanceBookings[index + 1].booking.requested_booking_time);

                //                         let currentAdVTime = this.advanceBookings[index].booking.estimated_booking_time ? this.advanceBookings[index].booking.estimated_booking_time : this.advanceBookings[index].booking.requested_booking_time;
                //                         let newdateAdvc = new Date(new Date(new Date(currentAdVTime)).getTime() + this.advanceBookings[index].booking.getDuration * 60000);
                //                         let differenceAdv = new Date(upcomingadv).getTime() - new Date(newdateAdvc).getTime();
                //                         differenceAdv = differenceAdv / 60000;
                //                         if (this.selectedServicesDuration <= Math.ceil(differenceAdv) && new Date(newdateAdvc).getTime() > new Date(timezoen).getTime()) {
                //                             times.push({ date: moment(newdateAdvc).format('YYYY-MM-DD HH:mm:ss'), available: true });
                //                         }
                //                     }
                //                 }
                //             }
                //         });
                // } catch (error) {

                // }
                this.proccessAdanceBookingRequest(booking, barbers, times);
                // if (times.length > 0 && this.selectedServicesDuration > this.coffeShopService.coffeShop.settings.advanced_bookings_time_interval) {
                //     let nextSlots = this.selectedServicesDuration / this.coffeShopService.coffeShop.settings.advanced_bookings_time_interval;
                //     let nextSlotsArray = nextSlots.toString().split(".");
                //     let noofSlots: number = 1;
                //     if (nextSlotsArray[1]) {
                //         noofSlots = (Number(nextSlotsArray[0]) + 1);
                //     } else {
                //         noofSlots = Number(nextSlotsArray[0]);
                //     }

                //     times.forEach((element, index) => {
                //         if (element.available && times[times.length -1] !== element) {
                //             let nextElements = [];
                //             for (let t = 1; t < noofSlots; t++) {
                //                 if (times[(index + t)]) {
                //                     nextElements.push(times[(index + t)].available);
                //                 } else {
                //                     nextElements.push(false);
                //                 }
                //             }
                //             element.available = nextElements.some(res => res == false) ? false : true;
                //         }

                //     });
                // }
                // if (times.length > 0 && this.todayBooking.length > 0) {
                //     times.forEach((element, index) => {
                //         this.todayBooking.forEach(todayBookings => {
                //             if (times[index + 1] && new Date(element.date) <= new Date(todayBookings.estimated_booking_time) && new Date(times[index + 1].date) >= new Date(todayBookings.estimated_booking_time)) {
                //                 element.available = false;
                //             }

                //             let newdate = new Date(new Date(new Date(todayBookings.estimated_booking_time)).getTime() + todayBookings.available_duration * 60000);
                //             if (times[index + 1] && new Date(element.date) <= (new Date(newdate)) && new Date(times[index + 1].date) >= new Date(newdate)) {
                //                 element.available = false;
                //             }
                //         });
                //     });
                // }
                if (times && times.length > 0) {
                    // times = this.CheckLastSlots(times);
                    // if(now === new Date(this.coffeShopService.selectedDate)){
                    //     times = this.CheckLastSlots(times);
                    // }
                    times = times.sort((a, b) => a.date.localeCompare(b.date));
                    times = this.removeDuplicates(times);
                }

                // if ((booking.date as any).getTime() === new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0).getTime()
                //     && this.coffeShopService.coffeShop.has_active_barbers) {
                //     this.checkBarberIsFree();
                // }
                this.timeLoading = false;
            }, (error: HttpErrorResponse) => {
                this.timeLoading = false;
                this.errorMessage = 'Not available time for this day.';
            });
    }

    public selectTime(bookingTime: any): void {
        this.disableContinueButton = false;
        if (!bookingTime.available || bookingTime.date === this.coffeShopService.selectedTime) { return; }
        this.coffeShopService.bookingType = bookingTime.booking_type ? bookingTime.booking_type : null
        bookingTime.date === this.coffeShopService.selectedTime ? this.coffeShopService.selectedTime = '' : this.coffeShopService.selectedTime = bookingTime.date;
    }

    private convertTZ(date: string | Date, tzString: string): Date {
        return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: tzString }));
    }

    ngOnDestroy() {
        this.coffeShopService.bookingTimes = [];
        this.coffeShopService.bookingDates = [];
        this.errorMessage = '';
    }

    async submit() {
        this.loading1 = true;
        if (typeof (this.booking) != "undefined" && this.booking != null && (this.booking.completed_at != null || this.booking.cancelled_at != null) && !this.isFromQueue) {
            let requestedBookingDate = moment(moment(this.coffeShopService.selectedDate).format('DD/MM/YYYY') + ' ' + this.coffeShopService.selectedTime, 'DD-MM-YYYY HH:mm');
            let advancedBooking: any = {
                date: moment(this.coffeShopService.selectedDate).format('DD/MM/YYYY'),
                time: this.coffeShopService.selectedTime,
                requested_booking_date_string: requestedBookingDate.format('dddd Do MMMM YYYY') + ' at ' + requestedBookingDate.format('h:mm a')
            }

            let services = {
                services: this.booking.services,
                totalCost: 0,
                availableTime: 0
            };
            let bookingType = 1;
            let selectedDate = moment(this.coffeShopService.selectedDate).format('DD/MM/YYYY');
            // let nowMoment = this.convertTZ(new Date(), this.coffeShopService.coffeShop.timezone.timezone);
            // if (moment(this.coffeShopService.selectedDate).format('DD/MM/YYYY') == nowMoment.toLocaleDateString()) {
            //     bookingType = 1;
            // } else {
            //     bookingType = 2;
            // }


            let nowMoment = this.convertTZ(new Date(), this.coffeShopService.coffeShop.timezone.timezone);
            let selectedTime = this.coffeShopService.selectedTime.split(':')
            let datese = new Date(this.coffeShopService.selectedDate).setHours(Number(selectedTime[0]), Number(selectedTime[1]));
            const timezoen = new Date(new Date().toLocaleString("en-US", { timeZone: this.coffeShopService.coffeShop.timezone.timezone }));

            if (new Date(datese).getTime() <= nowMoment.getTime()) {
                bookingType = 1;
            } else {
                bookingType = 2;
            }

            let booking = null;
            // let selectedDate = moment(this.coffeShopService.selectedDate).format('DD/MM/YYYY');
            let nowDate = moment(nowMoment).format('DD/MM/YYYY');
            let isadvance = false;

            if (this.selectedBarber.todays_cancelled_bookings.length > 0 && this.selectedBarber.current_chair_time_with_cancelled
                && selectedDate === nowDate) {
                await this.appendServicesToBooking();

                for (var element of this.selectedBarber.todays_cancelled_bookings) {
                    let differenceAdv = new Date(this.currentTimeZone).getTime() - new Date(element.estimated_booking_time).getTime();
                    differenceAdv = Math.ceil(differenceAdv / 60000);
                    differenceAdv = element.available_duration - differenceAdv;
                    let endTime = new Date(new Date(element.estimated_booking_time).getTime() + element.available_duration * 60 * 1000);
                    if (this.selectedServicesDuration <= element.available_duration && (moment(element.estimated_booking_time).format('HH:mm') == this.coffeShopService.selectedTime) && (new Date(timezoen).getTime() <= new Date(element.estimated_booking_time).getTime() || this.selectedServicesDuration <= differenceAdv)) {
                        booking = element;
                        // bookingType = 1;
                        break;
                    } else if (this.selectedServicesDuration <= differenceAdv &&
                        (new Date(datese).getTime() >= new Date(element.estimated_booking_time).getTime() && new Date(datese).getTime() < new Date(endTime).getTime())) {
                        booking = element;
                        isadvance = true;
                    }
                }
                if (typeof (this.selectedBarber.current_chair_time_with_cancelled) != 'undefined'
                    && this.selectedBarber.current_chair_time_with_cancelled != null
                    && this.selectedBarber.current_chair_time_with_cancelled.toString().trim() != '' && this.selectedBarber.todays_cancelled_bookings.length == 1) {
                    // if (this.selectedBarber.current_chair_time_with_cancelled.slice(-2) == 'PM') {
                    //     let time = this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.substring(0, this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.length - 2);
                    //     let times = time.split(":");
                    //     let actualSelectedTime = (Number(times[0]) + 12) + ':' + times[1];
                    //     if (actualSelectedTime == this.coffeShopService.selectedTime) {
                    //         // bookingType = 1;
                    //     } else {
                    //         booking = null;
                    //     }
                    // } else {
                    //     let time = this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.substring(0, this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.length - 2);
                    //     let times = time.split(":");
                    //     let hr = (Number(times[0]) - 12).toString().length == 1 ? ('0' + (Number(times[0]) - 12)) : (Number(times[0]) - 12);
                    //     let actualSelectedTime = hr + ':' + times[1];
                    //     if (actualSelectedTime == this.coffeShopService.selectedTime) {
                    //         // bookingType = 1;
                    //     } else {
                    //         booking = null;
                    //     }
                    // }
                    if (this.selectedBarber.current_chair_time_with_cancelled.slice(-2) == 'PM') {
                        // let time = this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.substring(0, this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.length - 2);
                        // let times = time.split(":");
                        // let actualSelectedTime = (Number(times[0]) + 12) + ':' + times[1];
                        this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string = this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.toUpperCase();
                        let actualSelectedTime = this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.includes('AM') ?
                            this.coffeShopService.convert12to24(this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.split('AM').join(' AM')) :
                            this.coffeShopService.convert12to24(this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.split('PM').join(' PM'));


                        if (actualSelectedTime == this.coffeShopService.selectedTime) {
                            // bookingType = 1;
                        } else {
                            booking = null;
                        }
                    } else {

                        this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string = this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.toUpperCase();
                        let actualSelectedTime = this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.includes('AM') ?
                            this.coffeShopService.convert12to24(this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.split('AM').join(' AM')) :
                            this.coffeShopService.convert12to24(this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.split('PM').join(' PM'));

                        // let time = this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.substring(0, this.selectedBarber.todays_cancelled_bookings[0].estimated_chair_time_string.length - 2);
                        // let times = time.split(":");
                        // let hr = Number(times[0]) > 9 ? ((Number(times[0]) - 12).toString().length == 1 ? ('0' + (Number(times[0]) - 12)) : (Number(times[0]) - 12)) : ('0' + (Number(times[0])));
                        // let actualSelectedTime = hr + ':' + times[1];
                        if (actualSelectedTime == this.coffeShopService.selectedTime) {
                            // bookingType = 1;
                        } else {
                            if (!isadvance)
                                booking = null;
                        }
                    }
                }
            }

            const today_day = moment(timezoen).format('dddd').toLocaleLowerCase();
            if (booking == null && !isadvance && nowDate == selectedDate && this.coffeShopService.user.advanced_booking_hours[`${today_day}`] == null) {
                bookingType = 1;
            }

            // this.navCtrl.push(ServiceSummaryPage, {
            //     services: services,
            //     shop: this.booking.team,
            //     barber: this.booking.staff_member.user,
            //     bookingType: bookingType,
            //     advancedBooking: bookingType == 2 ? advancedBooking : null,
            //     byStaff: false,
            //     fromLobby: false,
            //     fromStaffPanel: false,
            //     booking: null,
            //     guestUser: null,
            //     isFromReschedule: true
            // });
            this.navCtrl.push(ServiceSummaryPage, {
                services: services,
                shop: this.booking.team,
                barber: this.booking.staff_member.user,
                bookingType: bookingType,
                advancedBooking: bookingType == 2 && !booking ? advancedBooking : null,
                byStaff: false,
                fromLobby: false,
                fromStaffPanel: false,
                // booking: bookingType == 1 && booking ? booking : null,
                booking: booking ? booking : null,
                guestUser: null,
                isFromReschedule: true
            });
            this.viewCtrl.dismiss({ isRefresh: true });
            this.loading1 = false;

        } else {

            let booking: any = {
                bookingDate: moment(this.coffeShopService.selectedDate).format('DD/MM/YYYY'),
                bookingTime: this.coffeShopService.selectedTime
            }

            if (this.isFromQueue) {
                booking.team_member_id = this.selectedBarber.id;
                booking.old_team_member_id = this.booking.user_id;
            }

            this.http.post(`/bookings/${this.booking.id}/re-schedule`, booking)
                .subscribe((shop: any) => {
                    this.viewCtrl.dismiss({ isRefresh: true });
                    this.coffeShopService.bookingTimes = [];
                    this.coffeShopService.bookingDates = [];
                    this.errorMessage = '';
                    this.loading1 = false;

                }, error => {
                    this.apiErrorHandler.handleError(error);
                    this.loading1 = false;
                });
        }
    }

    async selectServices(barber, index) {
        this.dateTimeLoading = true;
        this.selectedIndex = index;
        this.selectedBarber = barber;
        this.errorMessage = null;

        this.coffeShopService.selectedDate = "";
        this.coffeShopService.selectedTime = "";

        this.todayCancelledBooking = [];
        this.todayBooking = [];
        await this.getavailableDuration();
        await this.getAdvAvailableDuration();
        if (this.todayBooking.length > 0) {
            this.todayBooking = this.todayBooking.sort((a, b) => parseFloat(b.id) - parseFloat(a.id));
        }
        this.chooseDateAndTime();
    }

    getavailableDuration() {
        if (this.selectedBarber && this.selectedBarber.todays_cancelled_bookings &&  this.selectedBarber.todays_cancelled_bookings.length > 0) {
            this.selectedBarber.todays_cancelled_bookings.forEach((booking: any) => {
                this.getAvailableDurationForCancelledBooking(booking).then((availableDuration) => {
                    booking.available_duration = availableDuration;
                    this.todayCancelledBooking.push(booking);
                });
            });
        }
    }

    getAdvAvailableDuration() {
        if (this.selectedBarber && this.selectedBarber.todays_booking &&  this.selectedBarber.todays_booking.length > 0) {
            this.selectedBarber.todays_booking.forEach((booking: any) => {
                this.getAvailableDurationForCancelledBooking(booking).then((availableDuration) => {
                    booking.available_duration = availableDuration;
                    this.todayBooking.push(booking);
                });
            });
        }
    }

    getAvailableDurationForCancelledBooking(booking) {
        return new Promise((resolve, reject) => {
            let serviceIds = [];
            booking.services.forEach((service) => {
                serviceIds.push(service.service_id);
            });

            this.http.get(`/bookings/${booking.id}/services/total-duration`)
                .subscribe((duration: any) => {
                    resolve(duration);
                }, (error) => {
                    reject(error);
                    this.errors = error;
                    this.apiErrorHandler.handleError(error)
                });
        })
    }

    appendServicesToBooking() {
        let count = this.selectedBarber.todays_cancelled_bookings.length - 1;
        return new Promise((resolve, reject) => {
            this.selectedBarber.todays_cancelled_bookings.forEach((booking, index) => {
                this.getAvailableDurationForCancelledBooking(booking).then((availableDuration) => {
                    booking.available_duration = availableDuration;
                    this.http.get(`/team/${this.coffeShopService.coffeShop.id}/members/${this.selectedBarber.id}/services?available_duration=${availableDuration}`)
                        .subscribe((services: any) => {
                            booking.full_services = services;
                            if (count === index) {
                                resolve(true)
                            }
                        }, (error) => {
                            reject(error);
                            this.errors = error;
                            this.apiErrorHandler.handleError(error)
                        });
                })
            });
        })
    }

}


// WEBPACK FOOTER //
// ./src/pages/reschedule/reschedule.ts